const socialItems = [
	{ title: "GitHub", link: "https://github.com/thobyza" },
	{ title: "Twitter", link: "https://x.com/thoby_za" },
	{ title: "LinkedIn", link: "https://www.linkedin.com/in/thoby-za/" },
];

export const Collab = () => {
    return (
        <>
            <section className="px-[16px] md:px-[0.8rem] pt-[5rem] md:pt-[1rem] pb-[2.5rem] bg-[#ebf3f3] font-jakarta">
                <section className="md:px-[5rem] border-t border-[#d1d8d7]">
                    <section className="flex flex-col md:flex-row md:justify-between pt-[1rem] md:pt-[2.5rem]">
                        <div className="flex pb-[4rem] md:pb-0 text-[2rem] md:text-[2.6rem] text-[#002921] font-medium tracking-tight leading-none">
                            Let's work together
                        </div>
                        <div className="flex flex-col md:flex-row gap-[2rem] md:gap-[5rem]">
                            {/* Write */}
                            <div className="border-t md:border-t-0 md:border-l border-[#d1d8d7] pt-[1rem] md:pt-0 md:pl-[1.1rem] flex flex-col justify-between gap-[3rem] md:gap-[5.5rem]">
                                <div className="flex flex-col gap-[0.8rem]">
                                    <h3 className="text-[1.65rem] text-[#002921] font-medium">
                                        Write
                                    </h3>
                                    <p className="text-[1rem] text-[#798f8b]">
                                        Discuss your project,
                                        <br />
                                        learn more about my methodologies, <br />
                                        or just say hello!
                                    </p>
                                </div>
                                <a
                                    href="mailto:thobyy.athaya@gmail.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-[0.5rem] group cursor-pointer text-[1.125rem] text-[#002921] tracking-tight font-medium leading-none"
                                >
                                    <span id="underline-effect">thobyy.athaya@gmail.com</span>
                                    <div className="flex items-center bg-[#E0FD60] p-[0.3rem] mt-[0.1rem] rounded-full group-hover:translate-x-1.5 transition ease-in-out delay-150">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024"
                                            className="h-[0.6rem] w-[0.6rem] rotate-[270deg] "
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8l316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496"
                                            />
                                        </svg>
                                    </div>
                                </a>
                            </div>
                            {/* My Socials */}
                            <div className="border-t md:border-t-0 md:border-l border-[#d1d8d7] pt-[1rem] md:pt-0 md:pl-[1.1rem] flex flex-col justify-between gap-[3rem] md:gap-[5.5rem]">
                                <div className="flex flex-col gap-[0.8rem]">
                                    <h3 className="text-[1.65rem] text-[#002921] font-medium">
                                        Get in Touch
                                    </h3>
                                    <p className="text-[1rem] text-[#798f8b]">
                                        Reach me out through my socials
                                    </p>
                                </div>
                                <div className="flex flex-col gap-[1rem]">
                                    {socialItems.map((item, index) => (
                                        <a
                                            key={index}
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center gap-[0.5rem] group cursor-pointer text-[1.125rem] text-[#002921] tracking-tight font-medium leading-none"
                                        >
                                            <span id="underline-effect">{item.title}</span>
                                            <div className="flex items-center bg-[#E0FD60] p-[0.3rem] mt-[0.1rem] rounded-full group-hover:translate-x-1.5 transition ease-in-out delay-150">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 1024 1024"
                                                    className="h-[0.6rem] w-[0.6rem] rotate-[270deg] "
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8l316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496"
                                                    />
                                                </svg>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </>
    );
}